
import { ShipmentShippingInfoController } from './controllers/shipmentShippingInfoController';
import  '../../../../../core/directives/readOnlyText/readOnlyTextDirective';
import '../../models/requestDetailEdit';
import '../../../addRequest/directives/consigneeSearch/consigneeSearchDirective';

export class ShipmentShippingInfoDirective implements angular.IDirective {
    template = require('./templates/shipmentShippingInfo.html');
    restrict = 'E';
    controller = ShipmentShippingInfoController;
    controllerAs = 'vm';
    bindToController = {
        requestDetailEdit: '=',
        isValid: '=',
        isLoading : '='
    };
    scope = {};
    replace = true;

    static factory(): angular.IDirectiveFactory {
        return () => new ShipmentShippingInfoDirective();
    }
}

angular.module('deliveryCreate.app').directive('shipmentShippingInfo', ShipmentShippingInfoDirective.factory());



/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/request/requestDetailEdit/directives/shipmentShippingInfo/shipmentShippingInfoDirective.ts
 **/